"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPrincipalBalanceDailyAverageQueryParams = void 0;
const common_1 = require("@finley-technologies/common");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const createPrincipalBalanceDailyAverageQueryParams = ({ postgresQuery, }) => {
    const { parameterConfig, variables } = postgresQuery;
    const { startDateFormula, endDateFormula, capitalProviderSlugs, } = parameterConfig;
    try {
        const { startDate, endDate, } = formula_engine_1.commonFormulas.evaluateStartAndEndDateFormulas({
            startFormula: startDateFormula.formula,
            endFormula: endDateFormula.formula,
            variables,
        });
        return {
            isValid: true,
            params: {
                startDate,
                endDate,
                capitalProviderSlugs: capitalProviderSlugs.slugs,
            },
        };
    }
    catch (err) {
        const errorMessage = `Detected error while creating Principal Balance Daily Average Query params [error:${(0, common_1.getErrorMessage)(err)}`;
        return {
            isValid: false,
            errors: [errorMessage],
        };
    }
};
exports.createPrincipalBalanceDailyAverageQueryParams = createPrincipalBalanceDailyAverageQueryParams;
//# sourceMappingURL=principalBalanceDailyAverageQueryParams.js.map